import type { QueryClient } from '@tanstack/react-query';

import {
  getActionsDashboardQueryKeyPrefix,
  getInternalQuotesOverviewQueryKeyPrefix,
  getOrdersOverviewQueryKeyPrefix,
  getQuotesOverviewQueryKeyPrefix,
  getTasksDashboardQueryKeyPrefix,
  getTeamAssignmentsQueryKeyPrefix,
} from '@frontend/api';

export const MULTISITE_DASHBOARD_DATA_REFETCH_INTERVAL_MS = 5 * 60 * 1000;

// Spread into queryOptions for any pane that participates in the polling cadence.
// Excludes useMultisiteDashboardUserSettings (preferences) and useCollection in
// AssignedToYou (label metadata only).
export const MULTISITE_DASHBOARD_POLL_QUERY_OPTIONS = {
  refetchInterval: MULTISITE_DASHBOARD_DATA_REFETCH_INTERVAL_MS,
  staleTime: MULTISITE_DASHBOARD_DATA_REFETCH_INTERVAL_MS,
  refetchOnMount: 'always',
  refetchOnWindowFocus: true,
} as const;

export const SYNCED_QUERY_KEY_PREFIXES = [
  getQuotesOverviewQueryKeyPrefix(),
  getOrdersOverviewQueryKeyPrefix(),
  getInternalQuotesOverviewQueryKeyPrefix(),
  getTeamAssignmentsQueryKeyPrefix(),
  getActionsDashboardQueryKeyPrefix(),
  getTasksDashboardQueryKeyPrefix(),
] as const;

export async function refreshMultisiteDashboardQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all(
    SYNCED_QUERY_KEY_PREFIXES.map((prefix) =>
      queryClient.refetchQueries({ queryKey: prefix }),
    ),
  );
}
